import { SelectComponent } from "@/components/select/Select";
import { AppColors } from "@/styles/colors";
import { Button, Card, Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { Trash2 } from "lucide-react";

interface Props {
  index: number;
  control: any;
  currentEquipo: { equipoId?: unknown } | undefined;
  watchedEquipos: { equipoId?: unknown }[];
  truckOptions: { label: string; value: string }[];
  truckFieldsLength: number;
  loadingTrucks: boolean;
  loadingCreate: boolean;
  removeTruck: (index: number) => void;
  handleAddTruck: () => void;
}

export const DriverTruckCard = ({
  index,
  control,
  currentEquipo,
  watchedEquipos,
  truckOptions,
  truckFieldsLength,
  loadingTrucks,
  loadingCreate,
  removeTruck,
  handleAddTruck,
}: Props) => {
  const raw = currentEquipo?.equipoId;
  const selected = Array.isArray(raw) ? raw?.[0] : raw;

  const selectedLabel = truckOptions.find(
    (o) => String(o.value) === String(selected ?? ""),
  )?.label;

  const disableDelete = truckFieldsLength <= 1 || loadingCreate;
  const showDelete = truckFieldsLength > 1;

  const selectedStr =
    selected !== undefined && selected !== null ? String(selected) : "";
  const occurrences = selectedStr
    ? (watchedEquipos ?? []).reduce((acc, t) => {
        const r = t?.equipoId;
        const s = Array.isArray(r) ? r?.[0] : r;
        return String(s ?? "") === selectedStr ? acc + 1 : acc;
      }, 0)
    : 0;
  const hasDuplicate = Boolean(selectedStr) && occurrences > 1;

  return (
    <Card.Root maxW="full" borderRadius="8px">
      <Card.Body
        paddingX="48px"
        paddingY="24px"
        borderRadius="8px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Flex justifyContent="space-between" alignItems="center" marginBottom="16px">
          <Flex gap="16px" alignItems="center">
            <Text fontWeight={700} fontSize="16px">
              {`Camión ${index + 1}`}
            </Text>
            {!!selectedLabel && (
              <>
                <Text color={AppColors.LIGHT_GRAY_TEXT}>|</Text>
                <Text fontWeight={600} fontSize="14px">
                  {selectedLabel}
                </Text>
              </>
            )}
          </Flex>

          {showDelete && (
            <Trash2
              cursor={disableDelete ? "not-allowed" : "pointer"}
              style={{ pointerEvents: disableDelete ? "none" : "auto" }}
              onClick={() => {
                if (!disableDelete) removeTruck(index);
              }}
              aria-label="Eliminar camión"
            />
          )}
        </Flex>

        <Grid templateColumns="repeat(4, 1fr)" gap="16px">
          <GridItem colSpan={2}>
            <SelectComponent
              control={control}
              name={`equipos.${index}.equipoId`}
              labelText="Camión y patente"
              placeholder="Seleccionar"
              items={truckOptions}
              loading={loadingTrucks}
              disabled={loadingTrucks || loadingCreate}
              required
              minHeight="40px"
              clearable
            />
            {hasDuplicate && (
              <Text
                color={AppColors.ERROR_TEXT}
                fontWeight={600}
                fontSize="12px"
                marginTop="6px"
                fontStyle="italic"
              >
                Este camión ya fue seleccionado.
              </Text>
            )}
          </GridItem>
        </Grid>

        {index === truckFieldsLength - 1 && (
          <Flex marginTop="20px">
            <Button
              onClick={handleAddTruck}
              disabled={loadingCreate || loadingTrucks}
              paddingX="12px"
              height="32px"
              borderRadius="6px"
              bgColor={AppColors.GREEN_PRIMARY}
              opacity={loadingCreate || loadingTrucks ? 0.6 : 1}
            >
              <Text fontWeight={600} fontSize="14px" color="white">
                Guardar y asignar otro camión
              </Text>
            </Button>
          </Flex>
        )}
      </Card.Body>
    </Card.Root>
  );
};
